import { api } from './client'

export interface NotificationInboxItem {
  id: string
  template: string
  variables: Record<string, string>
  category: string | null
  trigger: string | null
  read: boolean
  created_at: string
}

export interface QuietHours {
  enabled: boolean
  start: string
  end: string
  timezone: string
}

export interface CategoryOverride {
  whatsapp: boolean | null
  email: boolean | null
  telegram: boolean | null
  bypass_quiet_hours: boolean
}

export interface NotificationPreferences {
  whatsapp: boolean | null
  email: boolean | null
  telegram: boolean | null
  push: boolean | null
  quiet_hours: QuietHours | null
  category_overrides: Record<string, CategoryOverride> | null
}

export const notificationsApi = {
  /**
   * Fetch the notification inbox. Optionally filter to unread only.
   */
  getInbox: async (unreadOnly?: boolean): Promise<NotificationInboxItem[]> => {
    const params = unreadOnly ? '?unread_only=true' : ''
    const response = await api.get<{ items: NotificationInboxItem[], unread_count: number }>(
      `/api/v1/notifications/inbox${params}`
    )
    return response.items
  },

  /**
   * Mark a single notification as read.
   */
  markRead: (id: string): Promise<void> => {
    return api.post(`/api/v1/notifications/inbox/${id}/read`)
  },

  /**
   * Mark all notifications as read.
   */
  markAllRead: (): Promise<void> => {
    return api.post('/api/v1/notifications/inbox/read-all')
  },

  /**
   * Fetch notification preferences for the current user.
   */
  getPreferences: (): Promise<NotificationPreferences> => {
    return api.get<NotificationPreferences>('/api/v1/notifications/preferences')
  },

  /**
   * Update notification preferences for the current user.
   */
  updatePreferences: (prefs: Partial<NotificationPreferences>): Promise<NotificationPreferences> => {
    return api.put<NotificationPreferences>('/api/v1/notifications/preferences', prefs)
  },
}
